import { createSlice } from '@reduxjs/toolkit'
import { setIsClearingReduxFormState } from 'state/ui'

const initialState = {
  customer: {
    id: '',
    customerCommonIdentifierString: '',
    supplierType: '',
  },
  carrier: {
    id: '',
    customerCommonIdentifierString: '',
  },
  customers: [],
}

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      state.customer = action.payload
    },
    clearCustomer: state => {
      state.customer = initialState.customer
    },
    setCarrier: (state, action) => {
      state.carrier = action.payload
    },
    clearCarrier: state => {
      state.carrier = initialState.customer
    },
    setCustomers: (state, action) => {
      state.customers = action.payload
    },
    clearCustomers: state => {
      state.customers = initialState.customers
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsClearingReduxFormState, (state, action) => {
      if (action.payload) {
        state.customer = initialState.customer
        state.carrier = initialState.customer
        state.customers = initialState.customers
      }
    })
  },
})

export const { clearCustomer, clearCustomers, clearCarrier, setCustomer, setCustomers, setCarrier } =
  customerSlice.actions

export default customerSlice.reducer
